module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_vm._v("First published in the United States of America in 2014 by Chronicle Books LLC.")]), _vm._v(" "), _c('p', [_vm._v("First published in Sweden in 2013 by Norstedts.")]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2013 by Ida Magntorn and Norstedts.")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Cataloging-in-Publication Data available.")]), _vm._v(" "), _c('p', [_vm._v("ISBN: 978-1-4521-3717-9 (print)"), _c('br'), _vm._v("ISBN: 978-1-4521-4501-3 (epub2)"), _c('br'), _vm._v("ISBN: 978-1-4521-4520-4 (epub3)")]), _vm._v(" "), _c('p', [_vm._v("Design, photography, and illustration:"), _c('br'), _vm._v("Ida Magntorn"), _c('br'), _vm._v("Production: Cecilia Ljungstrom"), _c('br'), _vm._v("Prepress: Fälth & Hässler")]), _vm._v(" "), _c('p', [_vm._v("City map of New York, "), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#page_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 78")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/xhtml/09chapter03#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(": Map provided courtesy of Esri. Data for the map provided courtesy of Esri, DeLorme, NAVTEQ, increment P Corp., EPA, USGS, and NPS.")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, California 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36177294","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03copyright.vue
// module id = 63
// module chunks = 0